import { render, staticRenderFns } from "./editHeader.vue?vue&type=template&id=2e3da6ef&scoped=true&"
import script from "./editHeader.vue?vue&type=script&lang=js&"
export * from "./editHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3da6ef",
  null
  
)

export default component.exports